import {useMemo, useState} from "react";
import {checkValid} from "../model/checkValid";
import {useNavigate} from "react-router-dom";
import {MODAL_CONTENT} from "../model/modalContent";
import {SERVICE_CHECK_ITEMS, SERVICE_CHECK_ITEMS_MAPPING} from "../../../utils/constants";

const LOCAL_STORAGE_KEY = 'newCase'

export const useNewApplicationStep1 = ({ category, formData }) => {
  const [dialogContent, setDialogContent] = useState<MODAL_CONTENT | ''>('');
  const [disQualifyReason, setDisQualifyReason] = useState<string>('');

  const navigate = useNavigate();

  const checkboxes = useMemo(() => {
    return SERVICE_CHECK_ITEMS[category].map(itemKey => ({
      key: itemKey,
      label: SERVICE_CHECK_ITEMS_MAPPING[itemKey]
    }));
  }, [category])

  const submit = () => {
    setDisQualifyReason('');

    if (category === 'mobilePsychologist' && formData.BSRSScore >= 15) {
      setDialogContent(MODAL_CONTENT.NOT_QUALIFIED)
      setDisQualifyReason('建議尋求精神醫療專業諮詢');
      return;
    }
    if (checkValid({ category, formData })) {
      const storedCase = localStorage.getItem(LOCAL_STORAGE_KEY)
        ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)!)
        : {};

      const newCase = { ...formData, ...storedCase }
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newCase));
      navigate(`/newApplicationStep2/${category}`)
    } else {
      setDialogContent(MODAL_CONTENT.NOT_QUALIFIED)
    }
  }

  const onConfirm = () => setDialogContent('');
  return { dialogContent, checkboxes, disQualifyReason, submit, onConfirm }
}